"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = Collapse;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function Collapse(_ref) {
  let {
    open,
    children,
    speedPxPerSec = 1200,
    minDurationMs = 0
  } = _ref;
  const outerRef = (0, _react.useRef)(null);
  const innerRef = (0, _react.useRef)(null);
  const [rendered, setRendered] = (0, _react.useState)(open);

  /* styles */
  const [height, setHeight] = (0, _react.useState)(open ? "auto" : "0px");
  const [transition, setTransition] = (0, _react.useState)("none");

  /* for actual value in onTransitionEnd handler */
  const openRef = (0, _react.useRef)(open);
  openRef.current = open;

  /* mount DOM on open firstly */
  (0, _react.useEffect)(() => {
    if (open) setRendered(true);
  }, [open]);
  (0, _react.useLayoutEffect)(() => {
    if (!rendered) return;
    const outer = outerRef.current;
    const inner = innerRef.current;
    if (!outer || !inner) return;
    let raf1 = 0;
    let raf2 = 0;
    const currentPx = outer.getBoundingClientRect().height;
    const targetPx = open ? inner.scrollHeight : 0;
    const distance = Math.abs(targetPx - currentPx);
    const duration = Math.max(minDurationMs, Math.round(distance / speedPxPerSec * 1000));
    setTransition("none");
    setHeight(`${currentPx}px`);
    raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => {
        setTransition(duration === 0 ? "none" : `height ${duration}ms linear`);
        setHeight(`${targetPx}px`);
      });
    });
    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
    };
  }, [open, rendered, speedPxPerSec, minDurationMs]);
  const onTransitionEnd = e => {
    if (e.target !== e.currentTarget) return;
    if (e.propertyName !== "height") return;
    if (openRef.current) {
      setTransition("none");
      setHeight("auto");
    } else {
      setTransition("none");
      setHeight("0px");
      setRendered(false);
    }
  };
  if (!rendered) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: outerRef,
    onTransitionEnd: onTransitionEnd,
    style: {
      height,
      overflow: height === "auto" ? "visible" : "hidden",
      transition
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: innerRef
  }, children));
}